import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { addToCart } from 'store/slices/cartSlice';
import { CartIconBtn } from 'assets';
import CustomCounter from '../customCounter';
import './productCard.scss';
import {LazyLoadImage} from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/opacity.css';

const ProductCard = ({ border = false, product }) => {
  const [productCounter, setProductCounter] = useState(0);
  const dispatch = useDispatch();
  const addToCartHandle = () => {
    dispatch(addToCart({ product, productCounter }));
    setProductCounter(0);
  };

  return (
    <div className='productCard' style={{ border: border ? '1px solid rgba(0, 0, 0, 0.1)' : '' }}>
      <Link
        to={`/catalog/product/${product._id}`}
        className='productCard-img__wrap'
      >
          <div className="productCard-img">
            {product.found || product.imagePreview !== "" ? (
              <LazyLoadImage
                  src={product.imagePreview}
                  width={178}
                  height={167}
                  alt="Фото продукта"
                  effect="opacity"
              />
            ) : (
              <LazyLoadImage
                  src={"data:image/png;base64,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"}
                  width={178}
                  height={167}
                  alt="Фото продукта"
                  effect="opacity"
              />
            )}

          </div>
        {product.promoText && (
          <p
            className='productCard-promo'
            style={{ background: product.isPromotional ? '#e11e26' : '#74BE84' }}
          >
            {product.promoText}
          </p>
        )}
      </Link>
      <div className='productCard-top'>
        {product.available ? (
          <span className='productCard-status' style={{ color: '#74BE84' }}>
            В наличии
          </span>
        ) : (
          <span className='productCard-status' style={{ color: '#e11e26' }}>
            Нет в наличии
          </span>
        )}
        <Link
            to={`/catalog/product/${product._id}`}
            className='productCard-name'
        >
          {product.name}
        </Link>
      </div>
        {
            product.sku ? (
              <span className='productCard-status'>
                {product.sku}
              </span>
            ) : (
              <span className='productCard-status'>
                0
              </span>
            )
        }
        {
            product.isPromotional ? (
                <h4 className='productCard-price productCard-price--red'>
                    {product.price} c {' '}
                    <span className='productCard-price-old'> {product.oldprice} с</span>
                </h4>
            ) : (
                <h4 className='productCard-price'>
                    {product.price} с
                </h4>
            )
        }
      <div className='productCard-bottom'>
        <CustomCounter setProductCounter={setProductCounter} productCounter={productCounter} />
        {product.available && (
          <button className='productCard-btn btn-transitioned-animated' onClick={addToCartHandle}>
            в корзину
            <CartIconBtn />
          </button>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
